import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import FieldSet from 'flarum/common/components/FieldSet';
import Switch from 'flarum/common/components/Switch';
import { PREFERENCE_KEY } from './glossaryTerms';
const SETTINGS_PAGE = 'flarum/forum/components/SettingsPage';

/**
 * "Afficher les définitions du glossaire" on the member's settings page,
 * on by default (glossaryTerms.ts) - same pattern as champis-theme-large's
 * addThemeLargeSetting.tsx.
 */
export default function addGlossaryTermsSetting() {
  extend(SETTINGS_PAGE, 'oninit', function () {
    this.champisGlossaryTermsLoading = false;
  });
  extend(SETTINGS_PAGE, 'settingsItems', function (items) {
    items.add('champisGlossaryTerms', m(FieldSet, {
      className: "Settings-champisGlossaryTerms FieldSet--min",
      label: app.translator.trans('champis-others.forum.settings.glossary_heading')
    }, m(Switch, {
      state: this.user.preferences()?.[PREFERENCE_KEY] !== false,
      loading: this.champisGlossaryTermsLoading,
      onchange: value => {
        this.champisGlossaryTermsLoading = true;
        this.user.savePreferences({
          [PREFERENCE_KEY]: value
        }).then(() => {
          this.champisGlossaryTermsLoading = false;
          m.redraw();
        });
      }
    }, app.translator.trans('champis-others.forum.settings.glossary_label'), m("span", {
      className: "helpText"
    }, app.translator.trans('champis-others.forum.settings.glossary_help')))), -70);
  });
}